import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, RefreshCw, Layers } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    title: 'Evolve',
    description: 'We modernize your claims approach with advanced technology and data-driven insights to identify cost drivers early.',
    icon: RefreshCw
  }, {
    title: 'Grow',
    description: 'Scale your capabilities with our national network and comprehensive ancillary services without adding overhead.',
    icon: TrendingUp
  }, {
    title: 'Align',
    description: 'We partner closely with your team, aligning our medical management strategies with your specific organizational goals.',
    icon: Layers
  }];
  return <section className="py-24 bg-white overflow-hidden" data-id="element-162">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-164">
          <h2 className="text-brand-gold font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-165">
            Our Framework
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-brand-navy mb-6" data-id="element-166">
            The Arissa Approach
          </h3>
          <p className="text-lg text-gray-600" data-id="element-167">
            A proven methodology to transform your workers' compensation
            program.
          </p>
        </div>

        <div className="relative" data-id="element-168">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gray-100 -translate-y-1/2 z-0" data-id="element-169"></div>

          <div className="grid md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-170">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: index * 0.2
            }} className="relative text-center" data-id="element-171">
                  <div className="w-24 h-24 mx-auto bg-brand-navy rounded-full flex items-center justify-center mb-8 shadow-xl border-4 border-white relative group" data-id="element-172">
                    <div className="absolute inset-0 bg-brand-gold rounded-full scale-0 group-hover:scale-100 transition-transform duration-300 ease-out" data-id="element-173"></div>
                    <Icon className="w-10 h-10 text-white relative z-10" data-id="element-174" />

                    {/* Step Number Badge */}
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-brand-gold text-brand-navy font-bold rounded-full flex items-center justify-center border-2 border-white shadow-sm" data-id="element-175">
                      {index + 1}
                    </div>
                  </div>

                  <h4 className="text-2xl font-serif font-bold text-brand-navy mb-4" data-id="element-176">
                    {step.title}
                  </h4>
                  <p className="text-gray-600 leading-relaxed max-w-sm mx-auto" data-id="element-177">
                    {step.description}
                  </p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}